import { ChevronDownIcon } from '@heroicons/react/20/solid'
import classNames from 'classnames/dedupe'
import { ReactElement } from 'react'
import { twMerge } from 'tailwind-merge'

/**
 * Component to be used mainly in Comboboxes or Listboxes to show a chevron icon and rotate it when the combobox or listbox is open
 * @Prop open - status of the combobox. If `open === true` chevron should point up, if `open === false` chevron should point down
 * @returns ReactElement
 */
export function ChevronToggle({
  open,
  className,
  chevronClassName,
}: {
  open?: boolean
  className?: string
  chevronClassName?: string
}): ReactElement {
  return (
    <div className={twMerge(`pr-2 focus:outline-none`, className)}>
      <ChevronDownIcon
        className={classNames(`chevron chevron-icon`, chevronClassName, { [`rotate-180`]: open })}
        aria-hidden="true"
      />
    </div>
  )
}
